import { register } from "../app";

// Chart.js arrive par la balise <script> du CDN posée dans `admin/index.html.twig`, donc
// hors bundle : il peut ne pas être encore là quand le module s'exécute.
type ChartConstructor = new (canvas: HTMLCanvasElement, config: Record<string, unknown>) => unknown;

declare global {
    interface Window {
        Chart?: ChartConstructor;
    }
}

const selector = "canvas[data-chart]";
const maxAttempts = 10;
const retryDelay = 500;

const draw = (canvas: HTMLCanvasElement, attempt: number = 1): void => {
    // Un filtre changé entre-temps a remplacé le canvas : celui-ci n'est plus dans la page.
    if (!canvas.isConnected) {
        return;
    }

    const Chart = window.Chart;
    if (!Chart) {
        if (attempt < maxAttempts) {
            setTimeout(() => draw(canvas, attempt + 1), retryDelay);
        }

        return;
    }

    new Chart(canvas, {
        type: "bar",
        data: JSON.parse(canvas.dataset.chart!),
        options: {
            scales: {
                x: {
                    stacked: true,
                },
            },
            interaction: {
                mode: "index",
                intersect: false,
            },
            tooltips: {
                mode: "label",
                callbacks: {
                    label: (context: { dataset: { label: string }; formattedValue: string }) => `${context.dataset.label}: ${context.formattedValue}`,
                },
            },
        },
    });
};

// Le graphe était dessiné par un <script> en ligne du gabarit. `form-filter` recharge la zone
// filtrée par `innerHTML`, et un navigateur n'exécute jamais un script inséré ainsi : au premier
// filtre changé, le canvas restait vide. Enregistré ici, le dessin est rejoué par `init(target)`
// après chaque rechargement, comme les autres modules.
register(container => {
    container.querySelectorAll<HTMLCanvasElement>(selector).forEach(canvas => draw(canvas));
});
